import React from "react";
import Select from "react-select";
import "./FormField.css";

// component for form fields
// any props (other than label, icon, className and children) will be applied to the input element. this way you can specify the input type, event listeners, etc
// label prop will be used for the label html element
// icon prop (if there is one) should be the name of the icon without the mdi- prefix
// className prop will be added to the form-field container div
// any elements that would be displayed inside the field (like the password visibility toggle) should be inserted as a child element to FormField
// header prop is for elements to be displayed inline with the label, or otherwise above the input
// footer prop is for elements that need to be displayed below the input

function FormMultiSelect(props) {
  const {
    id,
    className,
    label,
    header,
    icon,
    children,
    footer,
    noMargin,
    ...inputProps
  } = props;
  const customStyles = {
    valueContainer: (provided, state) => ({
      ...provided,
      // height: "30px",
      padding: "0 6px",
      // overflowY: "scroll",
    }),
  };
  return (
    <div
      className={
        "form-multi-select" +
        (className ? " " + className : "") +
        (noMargin ? " mb-1" : " mb-3")
      }
    >
      {label && <label htmlFor={id}>{label}</label>}
      {header}
      <div>
        {icon ? <i className={"form-icon mdi mdi-" + icon}></i> : ""}
        {children}
        <Select
          styles={customStyles}
          id={id}
          {...inputProps}
          className={icon ? " form-input-with-icon" : ""}
          children={null}
        />
      </div>
      {footer}
    </div>
  );
}

export default FormMultiSelect;
